import { render, staticRenderFns } from "./CoachList.vue?vue&type=template&id=091dc9d6&"
import script from "./CoachList.vue?vue&type=script&lang=ts&"
export * from "./CoachList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports